import {
  average_overall_v4,
  average_by_area_v4,
  average_by_cluster_v4,
  active_by_area_v4,
  active_by_cluster_v4,
  active_overall_v4,
  expired_overall_v4,
  expired_by_area_v4,
  expired_by_cluster_v4,
  expired_by_branch_v4,
  active_by_branch_v4,
  average_by_branch_v4,
} from "../../v4-services/reports/sales_service";

import { actionTypes } from "../action_types";

const createSalesAction =
  (fetchFunction, actionType) => (data) => (dispatch) => {
    let processedPayload = [];
    let promises = [];

    if (Array.isArray(data.dates)) {
      data.dates.forEach((item) =>
        promises.push(fetchFunction({ ...data, ...item }))
      );
    } else {
      promises.push(fetchFunction(data));
    }

    return Promise.all(promises).then((resp) => {
      processedPayload = resp.map((element) => element.data);
      if (resp.every((response) => response.problem === null)) {
        dispatch({
          type: actionType,
          payload: processedPayload,
        });
      }
      return Promise.resolve(resp);
    });
  };

export const GetOverallAverage_v4 = createSalesAction(
  average_overall_v4,
  actionTypes.REPORTS_SALES_GET_OVERALL_AVERAGE
);

export const GetAverageByCluster_v4 = createSalesAction(
  average_by_cluster_v4,
  actionTypes.REPORTS_SALES_GET_CLUSTER_AVERAGE
);

export const GetAverageByArea_v4 = createSalesAction(
  average_by_area_v4,
  actionTypes.REPORTS_SALES_GET_AREA_AVERAGE
);

export const GetAverageByBranch_v4 = createSalesAction(
  average_by_branch_v4,
  actionTypes.REPORTS_SALES_GET_BRANCH_AVERAGE
);

export const GetOverallActive_v4 = createSalesAction(
  active_overall_v4,
  actionTypes.REPORTS_SALES_GET_OVERALL_ACTIVE
);

export const GetActiveByCluster_v4 = createSalesAction(
  active_by_cluster_v4,
  actionTypes.REPORTS_SALES_GET_CLUSTER_ACTIVE
);

export const GetActiveByArea_v4 = createSalesAction(
  active_by_area_v4,
  actionTypes.REPORTS_SALES_GET_AREA_ACTIVE
);

export const GetActiveByBranch_v4 = createSalesAction(
  active_by_branch_v4,
  actionTypes.REPORTS_SALES_GET_BRANCH_ACTIVE
);

export const GetOverallExpired_v4 = createSalesAction(
  expired_overall_v4,
  actionTypes.REPORTS_SALES_GET_OVERALL_EXPIRED
);

export const GetExpiredByCluster_v4 = createSalesAction(
  expired_by_cluster_v4,
  actionTypes.REPORTS_SALES_GET_CLUSTER_EXPIRED
);

export const GetExpiredByArea_v4 = createSalesAction(
  expired_by_area_v4,
  actionTypes.REPORTS_SALES_GET_AREA_EXPIRED
);

export const GetExpiredByBranch_v4 = createSalesAction(
  expired_by_branch_v4,
  actionTypes.REPORTS_SALES_GET_BRANCH_EXPIRED
);
